/* eslint-disable no-inner-declarations */
var galleryThumbs = new Swiper('.gallery-thumbs', {
    loop: false,
    spaceBetween: 2,
    slidesPerView: 2,
    slidesPerGroup: 2,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    navigation: {
        nextEl: '.gallery-thumbs__next',
        prevEl: '.gallery-thumbs__prev',
    },
    breakpoints: {
        480: {
            slidesPerView: 3,
            slidesPerGroup: 3,
        },
        576: {
            slidesPerView: 4,
            slidesPerGroup: 4,
        },
        768: {
            slidesPerView: 6,
            slidesPerGroup: 6,
        }
    }
});
var gallerySlider = new Swiper('.gallery-slider', {
    loop: false,
    spaceBetween: 0,
    autoHeight: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    thumbs: {
        swiper: galleryThumbs,
    },
    pagination: {
        el: '.swiper-pagination',
        type: "fraction",
    }
});

gallerySlider.on('slideChange', function () {
    var associatedThumbsGallery = $('.gallery-thumbs-container');

    if (associatedThumbsGallery.find('.swiper-slide-thumb-active').not('.swiper-slide-visible').length) {
        associatedThumbsGallery.find('.gallery-thumbs__next').trigger('click');
    }
});

// Render Youtube videos and allow pause on slideChange
if ($('.gallery-slider__media--video').not('.gallery-slider__media--mp4').length) {
    
    // Create youtube script api tag
    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    
    var playerDivs = document.querySelectorAll('.gallery-slider__media--video:not(.gallery-slider__media--mp4)');
    var playerDivsArr = [].slice.call(playerDivs);
    var players = new Array(playerDivsArr.length);
    var waypoints = new Array(playerDivsArr.length);
    var originDomain = window.location.origin;

    // When Youtube stuff is ready
    function onYouTubeIframeAPIReady() {
    
        // Create Youtube players
        playerDivsArr.forEach(function(e, i) {
            var ytID = playerDivs[i].getAttribute('data-yt-id');
    
            players[i] = new YT.Player(e.id, {
                height: '1920',
                width: '1080',
                videoId: ytID,
                host: 'https://www.youtube.com',
                playerVars: {
                    'playsinline': 1,
                    'showinfo': 1,
                    'origin': window.location.host,
                    'enablejsapi':1,
                    'widgetid':1
                },
                events: {
                    'onReady': galleryVideoStop,
                }
            })
        })
    }
    
    // Stop Youtube video on slide change
    function galleryVideoStop() {
        gallerySlider.on('slideChange', function () {
            $('.gallery-slider__media--video').not('.gallery-slider__media--mp4').each(function(i) {
                players[i].stopVideo();
            });
        });
    }
}

if ($('.gallery-slider__media--mp4').length) {
    gallerySlider.on('slideChange', function () {
        $('.gallery-slider__media--mp4').each(function(i) {
            $(this).trigger('pause');
        });
    });
}

(function($) {
    $(function() {
        var youtubeImage = $('[src*="https://img.youtube.com/"]');
        
        youtubeImage.each(function() {
            $(this)
                .closest('.gallery-thumbs__media')
                .addClass('gallery-thumbs__media--video');
        });
    });
})(jQuery);